/**
 * Client check for lead emails (DEV-571). `type="email"` lets "name@firma"
 * through, the API's `@IsEmail()` does not (it wants a domain with a TLD of
 * at least two letters), so the user only saw a generic 422 toast.
 */
const LEAD_EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.\d]{2,}$/;

export function isValidLeadEmail(value: string): boolean {
  return LEAD_EMAIL_PATTERN.test(value.trim());
}
